import { apiRequest } from "./client";

/**
 * Sprint 7 (Part 87) — server-side batch import contract:
 * POST /api/leads/import            (multipart file) → batch (uploaded)
 * GET  /api/leads/import/:id        → batch status (poll)
 * GET  /api/leads/imports           → batch list
 * POST /api/leads/import/:id/undo   → batch (undone)
 */
export const importsApi = {
  upload: async (file) => {
    const form = new FormData();
    form.append("file", file);
    return apiRequest("/api/leads/import", {
      method: "POST",
      body: form,
      headers: {}, // FormData sets its own multipart Content-Type
    });
  },
  get: (id) => apiRequest(`/api/leads/import/${id}`),
  list: async (params = {}) => {
    const query = new URLSearchParams({ page: "1", size: "20" });
    if (params.page) query.set("page", String(params.page));
    const data = await apiRequest(`/api/leads/imports?${query}`);
    return data?.items || [];
  },
  undo: (id) => apiRequest(`/api/leads/import/${id}/undo`, { method: "POST" }),
};
